/**
 * Logger to handler error message logging in the browser
 */
import _get from 'lodash/get'
import { get as getConfig } from 'config'
import {
  createLogger, ConsoleFormattedStream, ERROR, DEBUG,
} from 'browser-bunyan'
import NewRelicStream from 'bunyan-newrelic-stream/lib/browser'
import { getName, getVersion, getEnv } from './common'

/**
 * Get a logger for the browser
 */
export function getLogger (options = {}) {
  const {
    log: {
      browser: logConfig = {},
    } = {},
  } = getConfig()
  const {
    name = getName(),
    version = getVersion(),
    env = getEnv(),
    streams = [],
    level = _get(logConfig, 'level') || DEBUG,
    outputMode = _get(logConfig, 'outputMode') || 'json',
  } = options
  const loggerConfig = {
    name,
    version,
    env,
    streams,
  }
  switch (outputMode) {
    case 'short':
      loggerConfig.streams.push({
        level: ERROR,
        type: 'raw',
        stream: new NewRelicStream(),
      })
      loggerConfig.streams.push({
        level,
        stream: new ConsoleFormattedStream(),
      })
      break
    case 'json':
      loggerConfig.streams.push({
        level: ERROR,
        type: 'raw',
        stream: new NewRelicStream(),
      })
      break
    case 'none':
      break
    default:
      break
  }
  return createLogger(loggerConfig)
}

export default {
  getLogger,
}
